import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import './ReturningUserModal.css';

export default function ReturningUserModal({ open, onClose, prefillEmail = '' }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setEmail(prefillEmail || '');
      setMessage('');
      setLoading(false);
    }
  }, [open, prefillEmail]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event?.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) {
      setMessage('Enter the email address used for your premium purchase.');
      return;
    }
    setLoading(true);
    setMessage('Sending a secure recovery link...');
    try {
      await axios.post(`${API_BASE_URL}/api/premium-access-link`, { email: normalizedEmail });
      setMessage('If a paid account exists for that email, a recovery link has been sent. Check your inbox.');
    } catch (error) {
      setMessage('Unable to send the recovery link. Please try again or contact support.');
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={() => !loading && onClose?.()}>
      <form
        className="returning-user-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="returning-title"
        onClick={(event) => event.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <div className="returning-user-modal__body">
          <h3 id="returning-title">Restore premium access</h3>
          <p>We will email a secure link to the address tied to your paid plan.</p>
          <label htmlFor="returning-email">Premium purchase email</label>
          <input
            id="returning-email"
            type="email"
            value={email}
            placeholder="you@example.com"
            onChange={(event) => setEmail(event.target.value)}
            disabled={loading}
            autoFocus
            required
          />
          {message && <p className="returning-user-modal__message" role="status">{message}</p>}
        </div>
        <div className="returning-user-modal__actions">
          <button type="button" onClick={() => onClose?.()} disabled={loading}>Cancel</button>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Email me a recovery link'}
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
}
